import React, { useRef, useEffect, useState } from "react";
import { Row, Col, Input } from "reactstrap";

const InputHHMM = ({
  input,
  placeholder_HH,
  placeholder_MM,
  className,
  disabled,
  onChangeSymptomForm,
  semicolonTriggered,
}) => {
  const [hh, setHH] = useState("");
  const [mm, setMM] = useState("");

  const hhRef = useRef(null);
  const mmRef = useRef(null); // 👈 Ref to minute input
  const [shouldFocusHH, setShouldFocusHH] = useState(false);
  const [shouldFocusMM, setShouldFocusMM] = useState(false);
  const [hasFocusedInitially, setHasFocusedInitially] = useState(false);

  const updateScale = (val) => {
    input.onChange(val);
    onChangeSymptomForm({ target: { name: "scale", value: val } });
  };

  // Clear scale in redux when "HH;MM" input is incomplete. Note: This will not clear the active.value which is correct
  const clearScale = () => {
    input.onChange("");
    onChangeSymptomForm({ target: { name: "scale", value: "" } });
  };
  
  // 🧠 Handle one-time focus logic triggered by `;` from InputAmount
  useEffect(() => {
    if (!hasFocusedInitially && semicolonTriggered && typeof input.value === "string" && input.value.includes(";")) {
      const [hour = "", minute = ""] = input.value.split(";");
      const cleanHH = hour.replace(/\D/g, "").slice(0, 2);
      const cleanMM = minute.replace(/\D/g, "").slice(0, 2);

      setHH(cleanHH);
      setMM(cleanMM);

      if (cleanHH && cleanMM) {
        updateScale(`${cleanHH};${cleanMM}`);
      } else if (cleanHH && cleanHH.length === 2) {
        setShouldFocusMM(true);
      } else {
        setShouldFocusHH(true);
      }

      setHasFocusedInitially(true);
    }
  }, [semicolonTriggered, input.value, hasFocusedInitially]);

  // Autofocus handlers
  useEffect(() => {
    if (shouldFocusHH && hhRef.current) {
      hhRef.current.focus();
      setShouldFocusHH(false);
    }
    if (shouldFocusMM && mmRef.current) {
      mmRef.current.focus();
      setShouldFocusMM(false);
    }
  }, [shouldFocusHH, shouldFocusMM]);

  const handleHHChange = (e) => {
    const val = e.target.value;
    const isTypingForward = val.length > mm.length;

    if (/^\d{0,2}$/.test(val)) {
      setHH(val);
      if (val && mm) {
        updateScale(`${val};${mm}`);
      } else {
        clearScale();
      }
      // 👇 Auto-focus MM if 2 digits entered
      if (val.length === 2 && isTypingForward && mm.length === 0) {
        setShouldFocusMM(true);
      }
    }
  };

  const handleMMChange = (e) => {
    const val = e.target.value;
    const isTypingForward = val.length > mm.length;

    if (/^\d{0,2}$/.test(val)) {
      setMM(val);
      if (hh && val) {
        updateScale(`${hh};${val}`);
      } else {
        clearScale();
      }
      // 💡 Auto-focus HH only if MM is 2 digits AND HH is still blank
      if (val.length === 2 && isTypingForward && hh.length === 0) {
        setShouldFocusHH(true);      }

    }
  };

  // Block dropping text and the browser's "insertFromDrop"
  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  const handleBeforeInput = (e) => {
    if (e && e.nativeEvent && e.nativeEvent.inputType === "insertFromDrop") {
      e.preventDefault();
    }
  };

  return (
    <div className={`d-flex align-items-center ${className || ""}`} style={{ gap: "8px" }}>
      <Input
        type="text"
        placeholder={placeholder_HH}
        value={hh}
        onChange={handleHHChange}
        disabled={disabled}
        maxLength={2}
        innerRef={hhRef}
        style={{ width: "50%" }}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onBeforeInput={handleBeforeInput}
      />

      <span style={{ fontSize: "20px", lineHeight: "1" }}>;</span>

      <Input
        type="text"
        placeholder={placeholder_MM}
        value={mm}
        onChange={handleMMChange}
        disabled={disabled}
        maxLength={2}
        innerRef={mmRef}
        style={{ width: "50%" }}
        onDrop={handleDrop}
        onDragOver={handleDragOver}
        onBeforeInput={handleBeforeInput}
      />
    </div>
  );
};

export default InputHHMM;


// WEBPACK FOOTER //
// ./src/components/InputHHMM.js